import Axios from "axios";

export class Provider {
  // Set provider url
  constructor(apiUrl, headers) {
    this.providerUrl = `${apiUrl}/subscriptions/providers`;
    this.headers = headers;
  }

  async getDecryptedTaxId(id) {
    const url = `${this.providerUrl}/${id}/decrypt/tax-id`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }
}
